/**
 * Shared zod building blocks referenced by the generated cross-type schemas.
 */
import { z } from "zod";

export const common = {
  /**
   * A BSON ObjectId string.
   */
  objectId: z.string().regex(/^[0-9a-fA-F]{24}$/, "Expected a 24-character hex ObjectId"),
  /**
   * A UUID string.
   */
  uuid: z.uuid(),
  /**
   * A calendar date, e.g. "2026-07-14".
   */
  date: z.iso.date(),
  /**
   * An exact moment in ISO 8601 format, e.g. "2026-07-14T20:32:27Z". Offset
   * forms ("2026-06-10T23:02:00-04:00") are accepted too; the backend
   * normalizes them to UTC.
   */
  time: z.iso.datetime({ offset: true }),
};
